import styled from "styled-components";

export const ContainerDetalhes = styled.div`
width: 100%;
height: 100%;
display: flex;
flex-direction: column;
gap: 10px;

.detalhes__header{
  display: flex;
  align-items: center;
  gap: 5px;
  color: #2D3436;

  h3{
    font-weight: 600;
    font-size: 12px;
    margin: 0;
    padding: 0;
  }
}

.detalhe__propriedade{
  
}
`